module.exports = __webpack_public_path__ + "media/images/flags/bj-6056a538d4eb1cb1eac37ad70e9b270b.svg";